export const createLogoUrlWithFallback = (accountId: string) => {
  const baseUrl = 'https://res-s.cloudinary.com/prod/image/upload';
  const fallbackTransformation = 'd_console:cld_new_default_cloud_logo_regular_padding.svg/w_32,h_32,c_fill,dpr_2.0';
  const possibleAccountLogo = `console/customer-logos/${accountId}`;

  const logoUrlWithFallback = `${baseUrl}/${fallbackTransformation}/${possibleAccountLogo}`;

  return logoUrlWithFallback;
};
